import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Alert, AlertProps, AlertTitle, Collapse, IconButton } from "@mui/material";
import React, { useState } from "react";

type AlertAccordionProps = Omit<AlertProps, "action"> & {
  title: string;
  children: React.ReactNode;
};

const AlertAccordion: React.FC<AlertAccordionProps> = (props) => {
  const { title, children, ...alertProps } = props;

  const [showInfo, setShowInfo] = useState<boolean>(false);

  return (
    <Alert
      {...alertProps}
      sx={{ "& .MuiAlert-action": { pt: 0 } }}
      action={
        <IconButton onClick={() => setShowInfo(!showInfo)}>
          {showInfo ? <ExpandLess /> : <ExpandMore />}
        </IconButton>
      }
    >
      <AlertTitle sx={{ mb: 0 }}>{title}</AlertTitle>

      <Collapse
        in={showInfo}
        sx={{
          "& .MuiTypography-root": { font: "inherit" },
        }}
      >
        {children}
      </Collapse>
    </Alert>
  );
};

export default AlertAccordion;
